import Controller from '../abstracts/Controller';
import 'scss-templates/t-editorial.scss';

export default class EditorialController extends Controller {
  static get COMPONENTS() {
    return [
      'EditorialCoverInfiniteComponent',
      'ManifestoComponent',
      'CarouselComponent',
      'WishlistComponent',
    ];
  }
}
